import React, { useEffect } from 'react';
import { useMediaQuery, useTheme } from '@mui/material';
import { useAppDispatch } from '@/store';
import { setIsWideScreen } from '@/store/slices/uiSlice';

interface ResponsiveProviderProps {
  children: React.ReactNode;
}

export const ResponsiveProvider: React.FC<ResponsiveProviderProps> = ({ children }) => {
  const theme = useTheme();
  const dispatch = useAppDispatch();
  const isWideScreen = useMediaQuery(theme.breakpoints.up(900));

  useEffect(() => {
    dispatch(setIsWideScreen(isWideScreen));
  }, [isWideScreen, dispatch]);

  return <>{children}</>;
};